export { ReportSamCta } from "./ReportSamCta"
export type { ReportSamCtaProps } from "./ReportSamCta"
